<section class='demo-text title-animation-inout'>
    <div class='wrapper text'>
<!--        <h2>{{data_title.name}}</h2>-->
        <h2>{{title}}</h2>
    </div>
</section>
